import React, { useState, useEffect } from 'react';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { SubmitButton, SingleLink } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { Pagination } from '../../Res/Pagination';
import moment from 'moment';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_START, CASE_STATUS_RESERVE, CASE_STATUS_CANCEL, CASE_STATUS_ONBOARD, CASE_STATUS_RESIGN } from '../../../../item/ItemRecruitmentContractor';
import { api_getRecruitmentContractorStatusProcessList, api_setBlacklist } from '../../../../api/apiRecruitmentContractorStatus';
import { ReqRecruitmentContractorStatusProcessList, getCaseStatus } from '../../../../item/ItemRecruitmentContractorStatus';
import { uuid } from '../../../../item/ItemTools';
import { ReqBlacklist } from '../../../../item/ItemBlacklist';

export function RecruitmentContractorStatusProcess({ id, setIsLoading, ibl, ibls, n, setBL, isAdmin = false, isAll = false }) {
    const [isEdit, setIsEdit] = useState(false)
    const [recruitmentContractorStatusItem, setRecruitmentContractorStatusItem] = useState(null)
    const [tokenId, setTokenId] = useState("")
    const [resumeId, setResumeId] = useState("")
    const [isBlacklist, setIsBlacklist] = useState(false)
    const [isBlacklistStr, setIsBlacklistStr] = useState("")

    const [name, setName] = useState("")

    const [recruitmentContractorStatusProcessList, setRecruitmentContractorStatusProcessList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")

    useEffect(() => {
        console.log(id)
        if (id !== undefined && id !== tokenId) {
            // var obj = getval2Token("recruitmentContractorStatus", id)
            // console.log(obj)
            // var rId = getval2Token("resumeId", id)
            // setResumeId(obj.resumeId)
            // setCaseOwner(obj.item.caseOwner)
            // setCaseOwnerName(obj.item.caseOwnerName)
            setTokenId(id)
            var item = getval2Token("recruitmentContractorStatusDetail", id)
            setResumeId(item.caseContractor)
            setCaseOwner(item.caseOwner)
            setCaseOwnerName(item.caseOwnerName)
            console.log(item)
            setRecruitmentContractorStatusItem(item)
        }
    }, [id])

    useEffect(() => {
        if (resumeId !== undefined && resumeId !== "") {
            toSearch({ page: 1 })
        }
    }, [resumeId])

    useEffect(() => {
        setIsBlacklist(ibl)
        setIsBlacklistStr(ibls)
        setName(n)
    }, [ibl, ibls, n])

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqRecruitmentContractorStatusProcessList = new ReqRecruitmentContractorStatusProcessList({ caseContractor: resumeId, start, limit })
        if (items !== undefined)
            mReqRecruitmentContractorStatusProcessList.fromJson(items)
        getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusProcessList)
    }


    function getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusProcessList) {
        console.log(mReqRecruitmentContractorStatusProcessList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log(mReqCustomerContractList)
        api_getRecruitmentContractorStatusProcessList({
            mReqRecruitmentContractorStatusProcessList,
            success: (obj) => {
                console.log(obj)
                setRecruitmentContractorStatusProcessList(obj.list)
                setCount(obj.count)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function addBlacklist() {
        sendBlacklist(true)
    }

    function delBlacklist() {
        sendBlacklist(false)
    }

    function sendBlacklist(isDisabled){
        setIsLoading(true)
        var mReqBlacklist = new ReqBlacklist({
            accountId:resumeId,
            isDisabled: isDisabled?0:1,
        })
        console.log(mReqBlacklist)
        api_setBlacklist({
            mReqBlacklist,
            success:(obj)=>{
                setIsBlacklist(isDisabled)
                if(setBL !== undefined)
                    setBL(isDisabled)
                setIsLoading(false)
            },
            failure:(err)=>{
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            }
        })
    }

    var precautionsTitle = "派遣歷程 注意事項"
    var precautionsContent =
        <>
            <div className="row">
                <div className="col-md-12">
                    <p className="text-success">親愛的招募人員<br></br>
                        1. <br></br>
                        2. <br></br>
                        3. <br></br>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {!isBlacklist ?
                        <SubmitButton name={"加入黑名單"} action={addBlacklist} isRight={true} /> :
                        <SubmitButton name={"退出黑名單"} action={delBlacklist} isRight={true} />
                    }
                </div>
            </div>
        </>


    var processSuperTitle = name + isBlacklistStr
    var processTitle = "派遣案件歷程列表"
    var processContent =
        <>
            <RecruitmentContractorStatusProcessListBox recruitmentContractorStatusItem={recruitmentContractorStatusItem} list={recruitmentContractorStatusProcessList} srl={setRecruitmentContractorStatusProcessList} count={count} page={page} sp={toSearch} caseOwner={caseOwner} isAll={isAll} />
        </>

    return (
        <>
            <ContentBox title={precautionsTitle} titleSize={6} content={precautionsContent} hasDrawer={false} />
            <ContentBox superTitle={processSuperTitle} title={processTitle} titleSize={6} content={processContent} hasDrawer={false} />
        </>
    )
}


function RecruitmentContractorStatusProcessListBox({ recruitmentContractorStatusItem, list, srl, count, page, sp, caseOwner, isAll }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentContractorStatusProcessBox key={"RecruitmentContractorStatusDetail_ML" + i} recruitmentContractorStatusItem={recruitmentContractorStatusItem} item={list[i]} caseOwner={caseOwner} isAll={isAll} />)
            } else {
                itemList.push(<RecruitmentContractorStatusProcessBox key={"RecruitmentContractorStatusDetail_ML" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        // console.log(itemList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">案件日期</th>
                                    <th className="text-center sorting col-sm-1">案件狀態</th>
                                    <th className="text-center sorting col-sm-3">職缺資訊</th>
                                    <th className="text-center sorting col-sm-3">作業內容</th>
                                    <th className="text-center sorting col-sm-4">作業人 評論/備註</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentContractorStatusProcessBox({ recruitmentContractorStatusItem, item, caseOwner, isAll }) {
    const [mItem, setItem] = useState({})
    const [companyId] = useState(getUserInfoCompanyId())
    const [resumeId, setResumeId] = useState("")

    const [creatAt, setCreatAt] = useState("")
    const [caseStatus, setCaseStatus] = useState("")
    const [caseInfo, setCaseInfo] = useState("")
    const [caseProcessDescription, setCaseProcessDescription] = useState("")
    const [caseComment, setCaseComment] = useState("")



    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setResumeId(item.resumeId)
            setItem(item)
            setCreatAt(moment(item.creatAt).format('YYYY/MM/DD'))
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            // console.log(item)
            console.log(mReqRecruitmentContractorCaseInfo)
            setCaseInfo(mReqRecruitmentContractorCaseInfo)
            var cs = getCaseStatus(item, mReqRecruitmentContractorCaseInfo)
            // console.log(cs)
            setCaseStatus(cs.status)

            var tokenId = uuid(128, 64)
            setVal2Token('recruitmentContractorStatusItem', recruitmentContractorStatusItem, tokenId)
            switch (item.caseStatus) {
                case CASE_STATUS_RESERVE:
                    setCaseStatus(
                        <SingleLink link={"ReviseSOPCaseStatus1"}
                            tokenId={tokenId}
                            name={cs.status}
                            Key={"ReviseSOPCaseStatus1"}
                            val={item} >
                        </SingleLink>
                    )
                    break;
                case CASE_STATUS_CANCEL:
                    setCaseStatus(
                        <SingleLink link={"ReviseSOPCaseStatus2"}
                            tokenId={tokenId}
                            name={cs.status}
                            Key={"ReviseSOPCaseStatus2"}
                            val={item} >
                        </SingleLink>
                    )
                    break;
                case CASE_STATUS_ONBOARD:
                    setCaseStatus(
                        <SingleLink link={"ReviseSOPCaseStatus3"}
                            tokenId={tokenId}
                            name={cs.status}
                            Key={"ReviseSOPCaseStatus3"}
                            val={item} >
                        </SingleLink>
                    )
                    break;
                case CASE_STATUS_RESIGN:
                    setCaseStatus(
                        <SingleLink link={"ReviseSOPCaseStatus4"}
                            tokenId={tokenId}
                            name={cs.status}
                            Key={"ReviseSOPCaseStatus4"}
                            val={item} >
                        </SingleLink>
                    )
                    break;
                default:
                    setCaseStatus(cs.status)
                    break;

            }
            setCaseProcessDescription(mReqRecruitmentContractorCaseInfo.caseProcessDescription)


            var description = []
            mReqRecruitmentContractorCaseInfo.caseProcessDescription.map((item, i) => {
                if (item.name === undefined) {
                    description.push(
                        item
                    )
                } else {
                    var text = ""
                    if (isAll) {
                        text = item.name
                    } else {
                        text = item.id === caseOwner ? item.name : item.name.substr(0, 1) + "XX"
                    }
                    text += "：" + item.text
                    description.push(
                        text
                    )
                }
            })
            setCaseProcessDescription(description)

            var comment = []
            mReqRecruitmentContractorCaseInfo.caseComment.map((item, i) => {
                if (item.name === undefined) {
                    comment.push(
                        item
                    )
                } else {
                    var text = ""
                    if (isAll) {
                        text = item.name
                    } else {
                        text = item.id === caseOwner ? item.name : item.name.substr(0, 1) + "XX"
                    }
                    text += "：" + item.text
                    comment.push(
                        text
                    )
                }
            })
            setCaseComment(comment)
            // console.log(mReqRecruitmentContractorCaseInfo.caseComment)
        }
    }, [item])

    // useEffect(()=>{
    //     console.log(mItem)
    // },[mItem])
    return (
        <tr role="row">
            <td className="text-center">{creatAt}</td>
            <td className="text-center">{caseStatus}</td>
            <td className="text-center">{caseInfo.caseSignAt}&nbsp;{caseInfo.caseCompanyName}{caseInfo.caseCompanyName !== undefined ? ";" : ""}{caseInfo.caseCustomerPosition}</td>
            <td className="">
                {
                    typeof (caseProcessDescription) === "string" ? "" :
                        caseProcessDescription.map((item, i) => (
                            <div key={"caseProcessDescription" + i}>
                                {item}
                                <br></br>
                            </div>
                        ))
                }
            </td>
            <td className="">
                {
                    typeof (caseComment) === "string" ? "" :
                        caseComment.map((item, i) => (
                            <div key={"caseComment" + i}>
                                {item}
                                <br></br>
                            </div>
                        ))
                }
            </td>
        </tr>
    )
}
